export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '一起草支持多少人同时编辑一份文档？',
    answer: '一起草采用先进的实时同步技术，理论上支持无限数量的用户同时编辑同一份文档。在实际使用中，我们已测试过超过200人同时协作的场景，系统依然保持流畅稳定。当然，对于超大规模的协作场景，我们建议合理控制同时编辑的人数以获得最佳体验。',
  },
  {
    question: '如何保证文档数据的安全性？',
    answer: '数据安全是一起草的核心关注点。我们采用银行级别的AES-256加密技术保护您的数据，所有数据传输均通过SSL/TLS加密通道。文档数据在多个地理位置进行实时备份，确保数据不会丢失。我们还提供精细的权限控制，您可以设置文档的访问权限、编辑权限和分享范围。同时，一起草通过了ISO 27001信息安全管理体系认证。',
  },
  {
    question: '一起草支持哪些文件格式的导入和导出？',
    answer: '一起草原生支持Markdown格式编辑，同时支持导入和导出Word (.docx)、PDF、纯文本 (.txt) 和HTML等常见格式。对于PDF导出，我们提供了多种排版模板，确保导出的文档美观专业。对于合同类文档，我们还支持直接导出为适合打印签章的格式。',
  },
  {
    question: '是否支持离线编辑模式？',
    answer: '是的，一起草支持离线编辑模式。当您的设备暂时失去网络连接时，您可以继续编辑文档，系统会自动保存您的修改。当网络恢复后，一起草会自动同步离线期间的所有修改到云端，并智能处理可能出现的编辑冲突。这让您可以在任何环境下保持生产力。',
  },
  {
    question: '一起草有免费版本吗？',
    answer: '当然有！一起草提供永久免费的入门版，包含5GB云存储空间、最多10个协作文档、3人同时在线协作等核心功能，非常适合个人用户和小团队体验使用。对于需要更多容量和功能的中大型团队，我们提供专业版和企业版，具体方案请查看我们的定价页面。',
  },
  {
    question: '如何邀请团队成员加入一起草？',
    answer: '邀请团队成员非常简单。您可以通过邮箱邀请、生成分享链接或直接从企业通讯录导入三种方式邀请成员。被邀请的成员会收到邮件通知，点击链接即可注册加入。团队管理员可以在后台统一管理成员权限和访问控制。',
  },
  {
    question: '一起草支持移动端吗？',
    answer: '支持！一起草提供iOS和Android原生移动应用，以及适配移动浏览器的网页版。移动端保留了桌面版的核心编辑功能，包括实时协作、批注、版本管理等。您可以在通勤路上查看文档、回复批注，或在会议中用手机快速记录要点。',
  },
  {
    question: '如果发生编辑冲突怎么办？',
    answer: '一起草采用操作转换（OT）算法处理并发编辑，确保所有协作者的修改能够无冲突地合并。这意味着即使多人同时编辑同一段落，系统也能智能地整合所有修改，不会出现数据丢失或覆盖的情况。在任何时候，您都可以通过版本历史查看每个人的修改记录。',
  },
];